import { LoanMarketDiscount } from './LoanMarketDiscount';

export default LoanMarketDiscount;
